// Utveiing og merking: hvem massene veies ut/inn på (kundenr hos utsalget/mottaket) og hva lasset merkes med.

export const MASS_ACCOUNT_LIMITS = { customerName: 120, customerNumber: 40, reference: 60 };

// Stedet kundenr gjelder for: utsalget på hentested ved levering, mottaket på leveringssted ved bortkjøring.
export function massAccountSupplierId({ removal, pickupSupplierId, deliverySupplierId }) {
  const id = removal ? deliverySupplierId : pickupSupplierId;
  return id || null;
}

export function needsMassAccount(args) {
  return massAccountSupplierId(args) !== null;
}

const clip = (v, max) => String(v ?? '').slice(0, max);

export function defaultMassAccount({ billingProfile, project, remembered, supplierId } = {}) {
  return {
    customerName: clip(billingProfile?.name, MASS_ACCOUNT_LIMITS.customerName),
    customerNumber: clip(supplierId ? remembered?.[supplierId] : '', MASS_ACCOUNT_LIMITS.customerNumber),
    noAccount: false,
    reference: clip(project?.name, MASS_ACCOUNT_LIMITS.reference),
  };
}

// Feilmeldinger per felt; tomt objekt når alt er gyldig.
export function validateMassAccount(v) {
  const errors = {};
  const name = String(v?.customerName ?? '').trim();
  const number = String(v?.customerNumber ?? '').trim();
  const reference = String(v?.reference ?? '').trim();

  if (!name) errors.customerName = 'Skriv inn kundenavn';
  else if (name.length > MASS_ACCOUNT_LIMITS.customerName) errors.customerName = `Maks ${MASS_ACCOUNT_LIMITS.customerName} tegn`;

  if (!v?.noAccount) {
    if (!number) errors.customerNumber = 'Skriv kundenr, eller huk av for at du ikke har kundenr';
    else if (number.length > MASS_ACCOUNT_LIMITS.customerNumber) errors.customerNumber = `Maks ${MASS_ACCOUNT_LIMITS.customerNumber} tegn`;
  }

  if (reference.length > MASS_ACCOUNT_LIMITS.reference) errors.reference = `Maks ${MASS_ACCOUNT_LIMITS.reference} tegn`;
  return errors;
}

// Verdien som lagres på ordren.
export function buildMassAccount(v, supplierId) {
  const noAccount = !!v?.noAccount;
  return {
    customerName: String(v?.customerName ?? '').trim(),
    customerNumber: noAccount ? '' : String(v?.customerNumber ?? '').trim(),
    noAccount,
    reference: String(v?.reference ?? '').trim(),
    supplierId: supplierId ?? null,
  };
}

// Visningslinjer for sjåfør, bestiller og transportør. Tom liste når ordren ikke har massAccount.
export function massAccountLines(order) {
  const m = order?.massAccount;
  if (!m || !m.customerName) return [];
  const account = m.noAccount || !m.customerNumber ? 'Betaler på stedet' : `Kundenr ${m.customerNumber}`;
  const lines = [{ label: order.removal ? 'Veies inn på' : 'Veies ut på', value: `${m.customerName} · ${account}` }];
  if (m.reference) lines.push({ label: 'Merk med', value: m.reference });
  return lines;
}
